module.exports = __webpack_public_path__ + "img/4.d0986ac7.jpg";